import { useEffect, useMemo, useState } from "react";

export const DEFAULT_PAGE_SIZE = 10;

export function useTablePagination(rows, pageSize = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));

  useEffect(() => {
    setPage((current) => Math.min(current, totalPages));
  }, [totalPages]);

  const start = (page - 1) * pageSize;
  const pageRows = useMemo(
    () => rows.slice(start, start + pageSize),
    [rows, start, pageSize],
  );

  return { page, setPage, pageRows, pageSize, totalPages };
}

export default function TablePagination({ page, setPage, total, pageSize = DEFAULT_PAGE_SIZE, label = "records" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  const startPage = Math.max(1, Math.min(page - 2, totalPages - 4));
  const endPage = Math.min(totalPages, startPage + 4);

  return (
    <nav className="table-pagination" aria-label={`${label} pages`}>
      <span>{`Showing ${first}-${last} of ${total}`}</span>
      <div>
        <button type="button" disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</button>
        {Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).map((number) => (
          <button type="button" key={number} className={page === number ? "active" : ""} onClick={() => setPage(number)}>{number}</button>
        ))}
        <button type="button" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
      </div>
    </nav>
  );
}
